import { render, staticRenderFns } from "./MyPageLayout.vue?vue&type=template&id=2e69cab4&"
import script from "./MyPageLayout.vue?vue&type=script&lang=js&"
export * from "./MyPageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports